module.exports = __webpack_public_path__ + "img/IMG_9786_FoamcoreMatted.f4f07945.jpg";